import { AuthModule,AbstractSecurityStorage } from 'angular-auth-oidc-client';
import { OidcPrefixedStorageService } from './oidc-prefixed-storage.service';
import { authConfig } from './auth.config';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [
    AuthModule.forRoot({
      config: authConfig,
    })
  ],
  providers: [
    { provide: AbstractSecurityStorage, useClass: OidcPrefixedStorageService }
  ],
  exports: [AuthModule]
})
export class OidcConfigModule {}